import api from '../utils/api';

export async function listLlmProfiles() {
  const { data } = await api.get('/llm-profiles/');
  return data;
}
